import { useEffect } from 'react';

export const useWindowEvent = (event, callback) => {
    useEffect(() => {
        window.addEventListener(event, callback, { capture: true });
        return () =>
            window.removeEventListener(event, callback, { capture: true });
    }, [event, callback]);
};
